import { updateRecruitment } from "model/AboutUsModel";
import { updateFetchDetails } from "model/Partners";
import React, { useEffect, useState, useRef } from "react";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useUserContext } from "libs/context/UserContext";
import InputMask from "react-input-mask";
import { Offcanvas } from "bootstrap";
import CandidateTrackApplication from "pages/CandidateTrackApplication/candidate-track-application";
import {
    candidateUpdateProfileData,
} from "model/CandidateDetailsModel";

const CandidatePersonalDetailsSection = () => {
    const { candidateDetailsData, fetchCandidateDetailsDataForUpdate, loadingDetailsForUpdate } =
        useUserContext() || {};
    const [personalTab, setPersonalTab] = useState(true);

    const inputFields = {
        CandidateFName: "",
        CandidateLName: "",
        CandidateEmail: "",
        CandidatePhone: "",
        CandidateImageFile: "",
    };

    const [fields, setFields] = useState(inputFields);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const offcanvasRef = useRef(null);
    const offcanvasInstanceRef = useRef(null);

    const InterestedOrNot = localStorage?.getItem("InterestedOrNot")
    const [InterestedValue, setInterested] = useState(false);

    useEffect(() => {
        if (offcanvasRef.current) {
            offcanvasInstanceRef.current = new Offcanvas(offcanvasRef.current, {
                backdrop: true,
                scroll: true,
                keyboard: true,
            });
        }
    }, []);

    const openOffcanvas = () => {
        offcanvasInstanceRef.current?.show();
    };

    // ✅ Phone validation: must contain exactly 10 digits
    const validationSchema = Yup.object().shape({
        CandidateFName: Yup.string()
            .required("First Name is required")
            .min(2, "First Name must be at least 2 characters"),
        CandidateLName: Yup.string()
            .required("Last Name is required")
            .min(2, "Last Name must be at least 2 characters"),
        CandidateEmail: Yup.string()
            .required("Email is required")
            .email("Invalid email address"),
        CandidatePhone: Yup.string()
            .required("Phone number is required")
            .test(
                "len",
                "Phone number must be 10 digits",
                (val) => val && val.replace(/\D/g, "").length === 10
            ),
    });

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });

        try {
            await Yup.reach(validationSchema, name).validate(value);
            setErrors((prev) => ({ ...prev, [name]: "" }));
        } catch (err) {
            setErrors((prev) => ({ ...prev, [name]: err.message }));
        }
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched({ ...touched, [name]: true });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFields({ ...fields, CandidateImageFile: file });
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        try {
            await validationSchema.validate(fields, { abortEarly: false });
            setErrors({});

            // ✅ Clean phone number before sending (only digits)
            const cleanedPhone = fields.CandidatePhone.replace(/\D/g, "");

            const formData = new FormData();
            formData.append("CandidateFName", fields.CandidateFName);
            formData.append("CandidateLName", fields.CandidateLName);
            formData.append("CandidateEmail", fields.CandidateEmail);
            formData.append("CandidatePhone", cleanedPhone);

            if (fields.CandidateImageFile) {
                formData.append("CandidateImageFile", fields.CandidateImageFile);
            }

            let response = await candidateUpdateProfileData(formData);

            if (response?.IsSuccess) {
                toast.success(response?.Message || "Profile updated successfully");
                fetchCandidateDetailsDataForUpdate();
            } else {
                toast.error(response?.Message || "Failed to update profile");
            }
        } catch (err) {
            if (err.inner) {
                const formErrors = {};
                err.inner.forEach((e) => {
                    formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            } else {
                toast.error("Something went wrong!");
            }
        } finally {
            setSubmitLoading(false);
        }
    };

    const editPersonalDetails = () => {
        if (candidateDetailsData) {
            setFields({
                CandidateFName: candidateDetailsData.CandidateFName || "",
                CandidateLName: candidateDetailsData.CandidateLName || "",
                CandidateEmail: candidateDetailsData.CandidateEmail || "",
                CandidatePhone: candidateDetailsData.CandidatePhone || "",
                CandidateImageFile: "",
            });

            if (candidateDetailsData?.CandidateImageLink) {
                setImagePreview(candidateDetailsData?.CandidateImageLink);
            }
        }
        setPersonalTab(true);
    };

    useEffect(() => {
        setInterested(false)
        if (InterestedOrNot == 'Not-Interested') {
            setInterested(false)
        }
        else if (InterestedOrNot == 'Interested') {
            setInterested(true)
        }
    }, [InterestedOrNot]);

    useEffect(() => {
        editPersonalDetails();
    }, [candidateDetailsData]);

    return (
        <>
            {/* {(candidateDetailsData?.Interested) && */}
                <div className="active-mob-device d-xl-none">
                    <button
                        className="btn btn-primary-2 btn-callback-mob"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#application_status"
                        aria-controls="application_status"
                        onClick={openOffcanvas}
                    >
                        Track Application
                    </button>
                </div>
            {/* // } */}

            {loadingDetailsForUpdate ? (
                <div className="text-center py-5">
                    <Spinner color="primary" /> Loading...
                </div>
            ) : (
                <div
                    className="tab-pane fade show active mt-4"
                    id="pills-PersonalDetails"
                    role="tabpanel"
                    aria-labelledby="pills-PersonalDetails-tab"
                >
                    {personalTab && (
                        <div className="row container-padding-fix">
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner color="primary" /> Loading...
                                </div>
                            ) : (
                                <>
                                    {/* Profile Image Upload */}
                                    <div className="file-input-wrapper text-center">
                                        <label className="input-preview" htmlFor="img">
                                            <input
                                                className="input-preview__src"
                                                name="img"
                                                id="img"
                                                type="file"
                                                accept="image/png, image/gif, image/jpeg, image/jpg, image/svg+xml"
                                                onChange={handleImageChange}
                                            />
                                            {imagePreview ? (
                                                <img
                                                    src={imagePreview}
                                                    alt="preview"
                                                    className="rounded-circle"
                                                    style={{
                                                        width: "95px",
                                                        height: "96px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-camera" viewBox="0 0 16 16">
                                                    <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z" />
                                                    <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
                                                </svg>
                                            )}
                                        </label>
                                        <p>Upload Profile Picture</p>
                                        <span className="text-decoration-underline">
                                            Tap to Upload Picture here
                                        </span>
                                    </div>

                                    <div className="col-12">
                                        <hr className="my-4" />
                                    </div>

                                    {/* Form */}
                                    <div className="col-12">
                                        <form className="row g-3" onSubmit={handleSubmit}>
                                            {/* First Name */}
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="CandidateFName"
                                                        placeholder="Enter First Name"
                                                        value={fields.CandidateFName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label>First Name</label>
                                                </div>
                                                {errors.CandidateFName && (
                                                    <div className="text-danger small">
                                                        {errors.CandidateFName}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Last Name */}
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="CandidateLName"
                                                        placeholder="Enter Last Name"
                                                        value={fields.CandidateLName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label>Last Name</label>
                                                </div>
                                                {errors.CandidateLName && (
                                                    <div className="text-danger small">
                                                        {errors.CandidateLName}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Email */}
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="CandidateEmail"
                                                        placeholder="Enter Email"
                                                        value={fields.CandidateEmail}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label>Email</label>
                                                </div>
                                                {errors.CandidateEmail && (
                                                    <div className="text-danger small">
                                                        {errors.CandidateEmail}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Phone */}
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <InputMask
                                                        mask="(999)999-9999"
                                                        value={fields.CandidatePhone}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {(inputProps) => (
                                                            <input
                                                                {...inputProps}
                                                                type="text"
                                                                id="CandidatePhone"
                                                                name="CandidatePhone"
                                                                placeholder="Enter Phone"
                                                                className="form-control"
                                                            />
                                                        )}
                                                    </InputMask>
                                                    <label>Phone Number</label>
                                                </div>
                                                {errors.CandidatePhone && (
                                                    <div className="text-danger small">
                                                        {errors.CandidatePhone}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Submit */}
                                            <div className="d-flex justify-content-end mt-4">
                                                <div className="col-auto">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary-2 bg-dark"
                                                        disabled={submitLoading}
                                                    >
                                                        {submitLoading ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Saving...
                                                            </>
                                                        ) : (
                                                            "SAVE"
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    <hr />
                    <CandidateTrackApplication
                        offcanvasRef={offcanvasRef}
                        offcanvasInstanceRef={offcanvasInstanceRef}
                    />
                </div>
            )}
        </>
    );
};

export default CandidatePersonalDetailsSection;
